<template>
    <v-flex shrink class="entity-action">
        <v-btn
            v-if="link"
            flat
            class="pa-4 mr-0"
            :class="{ 'small-btn' : $bp.xsOnly}"
            color="primary"
            :href="currentEntity ? link : ''"
            target="_blank"
            :disabled="currentEntity == null || link == null"
        >
            {{ text }}
            <v-icon right dark>{{ icon }}</v-icon>
        </v-btn>
        <v-btn
            v-else
            flat
            class="pa-4 mr-0"
            :class="{ 'small-btn' : $bp.xsOnly}"
            color="primary"
            @mouseup.left="$emit('action')"
        >
            {{ text }}
            <v-icon right dark>{{ icon }}</v-icon>
        </v-btn>
    </v-flex>
</template>

<script>
	export default {
		props: ['icon', 'text', 'link', 'currentEntity', 'action']
	};
</script>